export const SvgWhiteHeart = () => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.3092 2.68428L12.3092 2.68426C11.8802 2.26539 11.243 2 10.2655 2C10.06 2 9.83713 2.0354 9.59346 2.11659L12.3092 2.68428ZM12.3092 2.68428C12.7338 3.0989 13 3.71121 13 4.65617V4.6562C13 5.43861 12.5976 6.36887 11.5103 7.45814L7.00039 11.8017L2.47561 7.43631L2.44194 7.40383L2.40608 7.37518C2.40609 7.37516 2.39656 7.36723 2.37546 7.34728C2.3526 7.32567 2.32232 7.29582 2.28374 7.25619C2.22904 7.19973 2.11061 7.06273 1.91375 6.81664L1.91372 6.81659C1.7426 6.6027 1.59131 6.38542 1.45913 6.16511L1.45911 6.16508C1.34963 5.98261 1.2383 5.73836 1.13303 5.42017L1.13299 5.42007C1.04029 5.13997 1 4.88664 1 4.6562C1 3.71118 1.26616 3.09889 1.69079 2.68429L1.69082 2.68426M12.3092 2.68428L1.69082 2.68426M8.88968 2.45639L8.88906 2.4568C8.61938 2.63402 8.39713 2.79426 8.21829 2.93716C8.03864 3.08097 7.86821 3.23349 7.70705 3.39462L7.00015 4.10142L6.2931 3.39478C6.13173 3.2335 5.96134 3.08099 5.7818 2.93728L8.88968 2.45639ZM8.88968 2.45639C9.10404 2.31529 9.33779 2.20182 9.59337 2.11662L8.88968 2.45639ZM5.11062 2.4566L5.11049 2.45652C4.89588 2.31533 4.66215 2.20192 4.40656 2.11665L5.11062 2.4566ZM5.11062 2.4566C5.38074 2.63425 5.60299 2.79434 5.78143 2.93698L5.11062 2.4566ZM1.69082 2.68426C2.11972 2.26545 2.75695 2 3.73433 2C3.93977 2 4.16249 2.03538 4.40623 2.11654L1.69082 2.68426Z"
				fill="white"
				stroke="white"
				stroke-width="2"
			/>
		</svg>
	);
};
